import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { EmptyCheckPipe } from './emptyCheck.pipe';
import { TranslatePipe } from '@ngx-translate/core';

@Pipe({
  name: 'prefixSuffix'
})

export class PrefixSuffixPipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private numberPipe: DecimalPipe,
    private translatePipe: TranslatePipe,
    private emptyCheckPipe: EmptyCheckPipe
  ) { }

  /**
   * @description Transforms a string by adding prefixes and suffixes with optional formatting.
   * @param {string} [value=''] - The input string containing placeholders for prefixes and suffixes.
   * @param {*} item - The object containing values to replace in the string.
   * @returns {*}  {string} - The transformed string with prefixes and suffixes applied.
   */
  transform(value: string = '', item: any): string {
    if (String.isNullOrUndefinedOrWhitespace(value)) {
      return '';
    }

    // value
    // 'prefix $identifier|pipeName:format$ suffix'

    let valueSubstrings = value.match(/\$.*?\$/g);

    let identifiers: string[] = [];

    if (valueSubstrings && valueSubstrings?.length > 0) {
      valueSubstrings.forEach(element => {
        var stringToTransform = element.substring(element.indexOf('$') + 1, element.lastIndexOf('$'));
        // 'identifier|pipeName:format'

        // string is a value from item object
        if (stringToTransform != '') {
          let prefixSuffixSubStrings = stringToTransform.split('|');
          // 0: 'identifier'
          // 1: 'pipeName:format'

          var identifier = prefixSuffixSubStrings[0];
          identifiers.push(identifier);

          // value has a pipe to do
          if (prefixSuffixSubStrings.length > 1) {
            let rawValue = JSON.stringify(item?.[identifier]);
            let valueToTransform = rawValue !== undefined ? JSON.parse(rawValue) : null;

            for (let i = 1; i < prefixSuffixSubStrings.length; i++) {
              const pipe = prefixSuffixSubStrings[i];

              let pipeSubstrings = pipe.split(':');
              // 0: 'pipeName'
              // 1: 'format'

              // pipe has format
              if (pipeSubstrings.length > 1) {
                var pipeName = pipeSubstrings[0];
                var format = pipeSubstrings[1];

                if (pipeSubstrings.length > 2) {
                  var format = pipeSubstrings.slice(1).join(':'); //The slice() method creates a new array starting from index 1 (i.e., skips the first element).
                }

                switch (pipeName) {
                  case 'date':
                    let isValidDate = !isNaN(Date.parse(valueToTransform));
                    if (isValidDate) {
                      let date = new Date(valueToTransform);
                      valueToTransform = this.datePipe.transform(date, format);
                      break;

                    } else {
                      valueToTransform = '';
                      break;
                    }

                  case 'number':
                    valueToTransform = this.numberPipe.transform(valueToTransform, format);
                    break;

                  case 'translate':
                    valueToTransform = this.translatePipe.transform(valueToTransform, format);
                    break;

                  case 'emptyCheck':
                    valueToTransform = this.emptyCheckPipe.transform(valueToTransform, format);
                    break;
                }

              } else {
                var pipeName = pipeSubstrings[0];

                switch (pipeName) {
                  case 'date':
                    let date = new Date(valueToTransform);
                    valueToTransform = this.datePipe.transform(date);
                    break;

                  case 'number':
                    valueToTransform = this.numberPipe.transform(valueToTransform);
                    break;

                  case 'translate':
                    valueToTransform = this.translatePipe.transform(valueToTransform);
                    break;

                  case 'emptyCheck':
                    valueToTransform = this.emptyCheckPipe.transform(valueToTransform);
                    break;
                }
              }
            }

            value = value.replace(element, valueToTransform);

          } else {
            if (!String.isNullOrUndefinedOrWhitespace(item[stringToTransform])) {
              value = value.replace(element, item[stringToTransform]);
            } else {
              value = value.replace(element, '');
            }
          }
        }
      });
    }

    if (identifiers?.some(x => item[x])) {
      return value;
    } else {
      return '';
    }
  }
}

